import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";

export default function RadioButtonsGroup({ Title, data, onChange, value }) {
  const intialVal = data.map((item) => {
    return item[value];
  });
  return (
    <FormControl style={{ margin: 10 }}>
      <FormLabel
        id="demo-radio-buttons-group-label"
        style={{ color: "#ffffff98", fontWeight: "600" }}
      >
        {Title}
      </FormLabel>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        defaultValue="female"
        name="radio-buttons-group"
        sx={{ display: "flex", flexDirection: "row" }}
        value={value}
      >
        {data?.map(({ value, id, lable }) => {
          return (
            <FormControlLabel
              key={id}
              value={value}
              control={
                <Radio
                  sx={{
                    color: "white",
                    "&.Mui-checked": {
                      color: "white",
                    },
                  }}
                />
              }
              style={{ color: "white" }}
              label={lable}
              onChange={(e) => onChange(e, Title)}
            />
          );
        })}
      </RadioGroup>
    </FormControl>
  );
}
